import {LocationInformation} from 'molbio/components/SaveLocationPicker';
import {TableSelection} from 'notebook/structured-tables/components/EntryTableDropdown';
import {WorklistFormType} from 'worklists/WorklistConstants';

/**
 * Given a LocationInformation and a display string for an entity potentially being saved, get error messages.
 * @param locationInfo Information about where to save entities and whether to add them to a worklist.
 * @param displayString The type of entity being saved, e.g. 'fragments', 'constructs', or 'primers'.
 */
export function getLocationInfoErrors({
  locationInfo,
  displayString,
}: {
  locationInfo: LocationInformation;
  displayString: 'constructs' | 'primers' | 'fragments';
}): Array<string> {
  const errors = [];
  const {targetFolderId, worklistParams} = locationInfo;
  if (targetFolderId == null) {
    errors.push(`A folder for ${displayString} is required.`);
  }
  if (worklistParams?.worklistFormType === WorklistFormType.NEW) {
    if (worklistParams?.newWorklistInfo?.name === '' || worklistParams.newWorklistInfo?.name == null) {
      errors.push(`A worklist name for ${displayString} is required.`);
    }
    if (worklistParams?.targetWorklistId != null) {
      errors.push(`Cannot add ${displayString} to both an existing worklist and a new worklist.`);
    }
  } else if (worklistParams?.worklistFormType === WorklistFormType.EXISTING) {
    if (worklistParams?.newWorklistInfo != null) {
      errors.push(`Cannot add ${displayString} to both an existing worklist and a new worklist.`);
    }
    if (worklistParams?.targetWorklistId == null) {
      errors.push(`A worklist for ${displayString} is required.`);
    }
  }
  return errors;
}

/**
 * Get validation errors for notebook entry integration fields.
 */
export function getNotebookEntryValidationErrors({
  addOutputsToEntry,
  selectedEntry,
  selectedTable,
  displayString,
}: {
  addOutputsToEntry: boolean;
  selectedEntry: string | null;
  selectedTable: TableSelection;
  displayString: 'construct' | 'primer' | 'fragment';
}): Array<string> {
  const errors = [];

  if (addOutputsToEntry) {
    if (!selectedEntry) {
      errors.push(`An entry is required when adding ${displayString} to a notebook entry.`);
    }
    if (!selectedTable) {
      errors.push(`A table is required when adding ${displayString} to a notebook entry.`);
    }
  }

  return errors;
}
